import styled from 'styled-components'

export const TextContainerWrapper = styled.section`
  margin: 0 auto;
  text-align: center;

  p {
    margin-top: 24px;
  }

  a,
  button {
    margin-top: 48px;
  }

  @media (max-width: 768px) {
    text-align: left;
    a,
    button {
      margin-top: 32px;
    }
  }
`

export const Title = styled.h1`
  font-family: Inter;
  font-size: 12.6px;
  font-weight: bold;
  line-height: 1.75;
  letter-spacing: 0.8px;
  color: var(--orange);
  text-transform: uppercase;
  text-align: center;
  margin: 0 auto 24px;
`
